__turbopack_context__.v({
  "action": "DealEntry-module__wX0d8a__action",
  "chevron": "DealEntry-module__wX0d8a__chevron",
  "cta": "DealEntry-module__wX0d8a__cta",
  "description": "DealEntry-module__wX0d8a__description",
  "details": "DealEntry-module__wX0d8a__details",
  "identity": "DealEntry-module__wX0d8a__identity",
  "meta": "DealEntry-module__wX0d8a__meta",
  "now": "DealEntry-module__wX0d8a__now",
  "off": "DealEntry-module__wX0d8a__off",
  "panel": "DealEntry-module__wX0d8a__panel",
  "priceRow": "DealEntry-module__wX0d8a__priceRow",
  "product": "DealEntry-module__wX0d8a__product",
  "rank": "DealEntry-module__wX0d8a__rank",
  "row": "DealEntry-module__wX0d8a__row",
  "source": "DealEntry-module__wX0d8a__source",
  "summary": "DealEntry-module__wX0d8a__summary",
  "term": "DealEntry-module__wX0d8a__term",
  "terms": "DealEntry-module__wX0d8a__terms",
  "tier1": "DealEntry-module__wX0d8a__tier1",
  "tier2": "DealEntry-module__wX0d8a__tier2",
  "tier3": "DealEntry-module__wX0d8a__tier3",
  "titleLine": "DealEntry-module__wX0d8a__titleLine",
  "unavailable": "DealEntry-module__wX0d8a__unavailable",
  "value": "DealEntry-module__wX0d8a__value",
  "was": "DealEntry-module__wX0d8a__was",
});
